import {
  invalidAvailability,
  invalidAvailabilityBorder,
  validAvailability,
  validAvailabilityBorder,
} from "@/styles/colors";
import { sharedStyles } from "@/styles/shared";
import { Box, SxProps, Typography } from "@mui/material";

const WorkingScaleCaption = () => {
  return (
    <Box sx={{ ...sharedStyles.horizontalContent, gap: 3 }}>
      <Box sx={sharedStyles.horizontalContent}>
        <Box
          sx={{
            ...styles.captionRectangle,
            backgroundColor: validAvailability,
            border: `1px solid ${validAvailabilityBorder}`,
          }}
        />
        <Typography>Aberto</Typography>
      </Box>

      <Box sx={sharedStyles.horizontalContent}>
        <Box
          sx={{
            ...styles.captionRectangle,
            backgroundColor: invalidAvailability,
            border: `1px solid ${invalidAvailabilityBorder}`,
          }}
        />
        <Typography>Fechado</Typography>
      </Box>
    </Box>
  );
};

export default WorkingScaleCaption;

const styles = {
  captionRectangle: {
    width: "30px",
    height: "20px",
  } as SxProps,
};
